import React, { Component } from "react";
import { reduxForm } from "redux-form";
import Input from "../../../../components/form/Input";
import Password from "../../../../components/form/Password";
import { ReduxCheckbox as Checkbox } from "../../../../components/form/Checkbox";
import Button from "../../../../components/form/Button";
import AutoComplete from "../../../../components/form/AutoComplete";
import CroField from "../../components/generalForm/CroField";
import { styles } from "../../index";
import { asyncForm } from "../../../../utils/asyncForm";
import { generateLogin } from "../../CroActions";
import askAction from "../AskAction";
import * as V from "../../../../utils/formValidation";

const minLength8 = V.minLength(8);

class OvmForm extends Component {
  componentWillMount() {
    this.props.breadcrumbs(this.props.breadcrumbsItems);
  }

  generateLogin = (data) => async () => {
    const { change, dispatch } = this.props;
    const { username, password } = await generateLogin(
      "/spravce/api/podpurne-organy/prihlasovaci-udaje/generovat",
      dispatch,
      data,
    );

    change("username", username);
    change("plainPassword", password);
  };

  disableGen = () => {
    const { ic } = this.props.loginData;
    return !ic;
  };

  render() {
    const {
      error,
      onSubmit,
      handleSubmit,
      onDelete,
      submitting,
      disabled,
      loginData,
      askAction,
      allowDatabox,
      allowBasic,
      isNew,
      canDelete,
    } = this.props;
    return (
      <form
        onSubmit={handleSubmit(onSubmit)}
        className="cro-form long-label ovmForm"
      >
        <div className="ovmForm__section ovmForm__fullWidth">
          <div className="ovmForm__grid">
            <CroField
              className="half"
              title="IČO"
              name="ic"
              component={Input}
              fullWidth
              disabled={disabled}
              validate={[V.required]}
            />
            <CroField
              className="half compact-input"
              title="Název"
              name="subject"
              component={Input}
              fullWidth
              disabled={disabled}
              validate={[V.required]}
            />
            <CroField
              className="half"
              title="Zkratka"
              name="abbreviation"
              component={Input}
              fullWidth
              disabled={disabled}
            />
            <CroField
              className="half"
              title="Organizace"
              name="organization"
              component={AutoComplete}
              fullWidth
              url="/api/ciselniky/organizace"
              validate={[V.required, V.isDictionary]}
            />
          </div>
        </div>

        {(allowDatabox || allowBasic) && (
          <div className="ovmForm__section ovmForm__fullWidth ovmForm__section--credentials">
            <div className="ovmForm__grid">
              {allowDatabox && (
                <CroField
                  className="half"
                  title="Datová schránka"
                  name="databox"
                  component={Input}
                  fullWidth
                  disabled={disabled}
                  validate={[V.required]}
                />
              )}
              {allowBasic && (
                <CroField
                  className="half"
                  title="Přihlašovací jméno"
                  name="username"
                  component={Input}
                  fullWidth
                  disabled={disabled}
                  validate={[V.required]}
                />
              )}
              {allowBasic && (
                <CroField
                  className="half"
                  title="Heslo"
                  name="plainPassword"
                  component={Password}
                  fullWidth
                  disabled={disabled}
                  validate={[V.required, minLength8]}
                />
              )}
            </div>
          </div>
        )}

        <div className="ovmForm__section">
          <div className="ovmForm__checks">
            <CroField
              title="Povoleno přihlášení přes datovou schránku"
              name="allowDatabox"
              component={Checkbox}
              disabled={disabled}
            />
            <CroField
              title="Povoleno přihlášení přes jméno + heslo"
              name="allowBasic"
              component={Checkbox}
              disabled={disabled}
            />
          </div>
        </div>

        <div className="ovmForm__section ovmForm__fullWidth">
          <CroField
            title="Důvod vytvoření"
            name="createNote"
            component={Input}
            multiline
            rows={3}
            fullWidth
            disabled={disabled || !isNew}
          />
        </div>

        {!disabled && (
          <div className="ovmForm__footer">
            <div className="ovmForm__footerInner">
              {error && <div className="error">{error}</div>}
              {!this.props.valid && this.props.submitFailed && !error && (
                <div className="error">
                  Povinná pole nejsou správně vyplněna.
                </div>
              )}
              <div className="ovmForm__hint">
                Povinná pole jsou označena hvězdičkou.
              </div>

              <div className="ovmForm__actions">
                <Button
                  type="button"
                  style={styles.buttons}
                  label="Uložit"
                  disabled={submitting || disabled}
                  onClick={handleSubmit(onSubmit)}
                />
                {!isNew && canDelete && (
                  <Button
                    type="button"
                    style={styles.buttons}
                    label="Smazat"
                    disabled={submitting || disabled}
                    onClick={askAction(
                      onDelete,
                      "Opravdu chcete smazat podpůrný orgán?",
                        true
                    )}
                  />
                )}
                <Button
                  type="button"
                  style={styles.buttons}
                  label="Generovat jméno a heslo"
                  disabled={submitting || disabled || this.disableGen()}
                  onClick={this.generateLogin(loginData)}
                />
                {this.props.onShowHistory && (
                  <Button
                    type="button"
                    style={styles.buttons}
                    label="Zobrazit historii"
                    onClick={this.props.onShowHistory}
                  />
                )}
              </div>
            </div>
          </div>
        )}
      </form>
    );
  }
}

export default reduxForm({
  form: "ovmForm",
  initialValues: { allowDatabox: true },
})(askAction(asyncForm(OvmForm)));
